import React from "react";
import { Link } from "react-router-dom";

/**
 * Summary layout component for Financial Insights Subscriptions (FI)
 */
export const FinancialInsightsSummary = ({
  planName,
  displayLabel,
  netAmount,
  totalAmount,
  onOpenFullList,
}) => {
  const isFree = planName?.toLowerCase() === "free";

  // Check if a discount has been applied to show a visual indicator
  const hasDiscount = parseFloat(netAmount) > parseFloat(totalAmount);

  return (
    <div
      className="checkout-summary-card"
      style={{ display: "flex", flexDirection: "column", gap: "32px" }}
    >
      <h4
        style={{
          margin: 0,
          padding: 0,
          color: "#2b2b2b",
          fontSize: "20px",
          fontStyle: "normal",
          fontWeight: "700",
        }}
      >
        Order Summary
      </h4>
      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            Service:
          </p>
          <span
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            Financial Insights
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            Billing:{" "}
          </p>
          <span
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            {displayLabel}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            Amount:{" "}
          </p>
          <span
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
              textDecoration: hasDiscount ? "line-through" : "none", // Strikethrough if discounted
              opacity: hasDiscount ? 0.6 : 1,
            }}
          >
            ${netAmount}
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <p
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            Taxes & Fees:{" "}
          </p>
          <span
            style={{
              color: "#40464b",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "140%",
            }}
          >
            $0.00
          </span>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontWeight: "700",
            fontSize: "14px",
            borderTop: "1px dashed #EAEAEA",
            paddingTop: "14px",
          }}
        >
          <span style={{ flexGrow: 1, color: "#2b2b2b" }}>
            Total Due Today:
          </span>
          <span style={{ color: hasDiscount ? "#28a745" : "#003273" }}>
            {" "}
            {/* Green text if discounted */}${totalAmount}
          </span>
        </div>
      </div>
      <div>
        <p
          style={{
            margin: "0 0 8px 0",
            fontWeight: "500",
            fontSize: "14px",
            color: "#2b2b2b",
          }}
        >
          What's included?
        </p>
        <span
          style={{
            color: "#8c9093",
            fontSize: "14px",
            fontStyle: "normal",
            fontWeight: "300",
            lineHeight: "140%",
          }}
        >
          {isFree ? (
            <>
              <i style={{ color: "#8c9093" }}>1 connected institution</i>,{" "}
              <i style={{ color: "#8c9093" }}>1 active budget</i>,{" "}
              <i style={{ color: "#8c9093" }}>basic notifications</i>,{" "}
              <i style={{ color: "#8c9093" }}>historical ledger snapshots</i>
            </>
          ) : (
            <>
              <i style={{ color: "#8c9093" }}>unlimited institutions</i>,{" "}
              <i style={{ color: "#8c9093" }}>unlimited accounts</i>,{" "}
              <i style={{ color: "#8c9093" }}>unlimited budgets</i>,{" "}
              <i style={{ color: "#8c9093" }}>custom reports generation</i>,{" "}
              <i style={{ color: "#8c9093" }}>advanced notifications</i>
            </>
          )}
          {" | "}
          <span
            onClick={onOpenFullList}
            style={{
              color: "#006cd1",
              cursor: "pointer",
              textDecoration: "underline",
              fontWeight: "400",
            }}
          >
            Full List
          </span>
        </span>
      </div>
    </div>
  );
};

/**
 * Summary layout component for One-Time Tax Filings (TAX)
 */
export const TaxFilingSummary = ({ amount }) => (
  <div className="checkout-summary-card" style={{ padding: "16px" }}>
    <h4 style={{ marginBottom: "8px", color: "#003273" }}>
      Tax Filing Service Order
    </h4>
    <p style={{ fontSize: "14px", color: "#666", marginBottom: "16px" }}>
      One-time secure tax processing fee
    </p>
    <div
      style={{ height: "1px", background: "#EAEAEA", margin: "12px 0" }}
    ></div>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontWeight: "bold",
        fontSize: "16px",
      }}
    >
      <span>Due Today:</span>
      <span style={{ color: "#003273" }}>{amount}</span>
    </div>
  </div>
);

/**
 * Default fallback summary card container component
 */
export const DefaultOrderSummary = ({ amount }) => (
  <div className="checkout-summary-card" style={{ padding: "16px" }}>
    <h4 style={{ marginBottom: "8px", color: "#003273" }}>Order Summary</h4>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontWeight: "bold",
        fontSize: "16px",
        marginTop: "12px",
      }}
    >
      <span>Due Today:</span>
      <span>{amount}</span>
    </div>
  </div>
);

// Master layout assignment registry dictionary
export const SUMMARY_COMPONENTS_MAP = {
  FI: FinancialInsightsSummary,
  TAX: TaxFilingSummary,
};
